export function installDirectives (Vue) {
  Vue.directive('flex-order', (el, { value }) => {
    el.style.order = value
  })
}




// WEBPACK FOOTER //
// ./src/directives/index.js